import { useAuth } from "./context/AuthContext";
import { Navigate, Outlet } from "react-router";

const PublicRoute = () => {
    const { email, loading, userVerified } = useAuth();

    if (loading) return <div>Loading...</div>;

    if (email) {
        if (userVerified === "IN_REVIEW") return <Navigate to="/profilepending" />;
        if (userVerified === "PENDING") return <Navigate to="/profileform" />;
        if (userVerified === "VERIFIED") return <Navigate to="/dashboard" />;
    }

    return <Outlet />;
};

export default PublicRoute;